import axios from '../api';

class MerchantService {
  // Get merchant's business
  async getBusiness() {
    const response = await axios.get('/api/merchant/business');
    return response.data.business;
  }

  // Update merchant's business
  async updateBusiness(data: any) {
    const response = await axios.put('/api/merchant/business', data);
    return response.data;
  }

  // Register a new business (submitted for admin approval)
  async createBusiness(data: any) {
    const response = await axios.post('/api/merchant/business', data);
    return response.data;
  }

  // Get merchant's surprise boxes
  async getSurpriseBoxes(params?: { page?: number; limit?: number }) {
    const response = await axios.get('/api/merchant/surprise-boxes', { params });
    return response.data;
  }

  // Get single surprise box
  async getSurpriseBox(id: string) {
    const response = await axios.get(`/api/merchant/surprise-boxes/${id}`);
    return response.data.surpriseBox;
  }

  // Create surprise box
  async createSurpriseBox(data: any) {
    const response = await axios.post('/api/merchant/surprise-boxes', data);
    return response.data;
  }

  // Update surprise box
  async updateSurpriseBox(id: string, data: any) {
    const response = await axios.put(`/api/merchant/surprise-boxes/${id}`, data);
    return response.data;
  }

  // Mark as sold out
  async markAsSoldOut(id: string) {
    const response = await axios.put(`/api/merchant/surprise-boxes/${id}/sold-out`);
    return response.data;
  }

  // Reset inventory (mark as active with full stock)
  async resetInventory(id: string, totalBoxes: number) {
    const response = await axios.put(`/api/merchant/surprise-boxes/${id}/reset-inventory`, { totalBoxes });
    return response.data;
  }

  // Delete surprise box
  async deleteSurpriseBox(id: string) {
    const response = await axios.delete(`/api/merchant/surprise-boxes/${id}`);
    return response.data;
  }

  // Get merchant's orders
  async getOrders(params?: { page?: number; limit?: number }) {
    const response = await axios.get('/api/merchant/orders', { params });
    return response.data;
  }

  // Get single order
  async getOrder(id: string) {
    const response = await axios.get(`/api/merchant/orders/${id}`);
    return response.data.order;
  }

  // Update order status
  async updateOrderStatus(id: string, status: string) {
    const response = await axios.put(`/api/merchant/orders/${id}/status`, { status });
    return response.data;
  }

  // Mark an order's payment as received (cash collected on pickup)
  async markOrderPaid(id: string) {
    const response = await axios.put(`/api/merchant/orders/${id}/payment`, { status: 'completed' });
    return response.data;
  }

  // Get dashboard stats
  async getStats() {
    const response = await axios.get('/api/merchant/stats');
    return response.data.stats;
  }

  // Get merchant's reviews
  async getReviews(params?: { page?: number; limit?: number }) {
    const response = await axios.get('/api/merchant/reviews', { params });
    return response.data;
  }

  // Get merchant analytics
  async getAnalytics(params?: { period?: string }) {
    const response = await axios.get('/api/merchant/analytics', { params });
    return response.data;
  }

  // Get customer segments
  async getCustomerSegments() {
    const response = await axios.get('/api/merchant/customers/segments');
    return response.data;
  }

  // Send notification to customers
  async sendNotification(data: { title: string; message: string; segment: string; pincode?: string }) {
    const response = await axios.post('/api/merchant/notifications/send', data);
    return response.data;
  }

  // Get notification history
  async getNotificationHistory(params?: { page?: number; limit?: number }) {
    const response = await axios.get('/api/merchant/notifications/history', { params });
    return response.data;
  }
}

const merchantService = new MerchantService();
export default merchantService;
